import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import { LogoutPage } from './LogoutPage';

const NoPermission = (props) => {
  const { location } = props;
  const { pathname } = location;

  /**
   * 隐藏第三级菜单
   */
  useEffect(() => {
    const itemsToHide = [
      document.querySelector('.sec-top-tab'),
      document.querySelector('aside.sidebar'),
    ];
    itemsToHide.forEach(elm => {
      if (!elm) return;
      elm.style.setProperty('display', 'none');
    });
    return () => {
      // 记得恢复显示，不然切了路由也会继续消失
      itemsToHide.forEach(elm => {
        if (!elm) return;
        elm.style.removeProperty('display');
      });
    };
  }, []);

  /**
   * 访问不存在的路由直接重定向到首页
   */
  if (!window._noPermissionRoutes.has(pathname)) {
    return (<Redirect to="/" />);
  }

  /**
   * 根据路由返回定制化的页面
   */
  if (pathname === '/system/leadsForward/Api') {
    return (<LogoutPage {...props} />);
  }
  /**
   * 剩余的无权限页面返回通用的错误提示
   */
  return (<LogoutPage isCommon {...props} />);
};

export default NoPermission;
